import { Component, OnDestroy, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { TipIzvestajaVeleprodaja } from '@kodit/core/data-api';

@Component({
  selector: 'kodit-kpo-knjiga-page',
  templateUrl: './poslovanje-page.component.html',
  styleUrls: ['./poslovanje-page.component.scss'],
})
export class PoslovanjePageComponent implements OnInit, OnDestroy {
  tipPoslovanjaOptions: SelectItem[];

  optionSelected: TipPoslovanja = TipPoslovanja.KPO;

  constructor() {
    this.tipPoslovanjaOptions =
      [
        {label: 'KPO knjiga', value: TipPoslovanja.KPO}
      ];
  }

  ngOnInit(): void {
    //this._godinaService.enableShouldDisplayRacunYearFilter();
  }

  handleOptionChanged(value: TipPoslovanja) {
    this.optionSelected = value;
  }

  ngOnDestroy() {
    //this._godinaService.resetShouldDisplayRacunYearFilter();
  }

  public readonly TipPoslovanja = TipPoslovanja;
}

export enum TipPoslovanja {
  KPO = 0
}
